<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <v-range-slider
      :name="schema.model"
     :id="generateId(schema.model)"
      :rules="rules"
      :value="schema.value"
      v-bind="schema.attributes"
      :disabled="schema.readonly"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributes.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-range-slider>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';
export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  methods: {
    onChange: async function () {
      this.changeEvents();
    },
  }
};
</script>
